import { selector } from 'recoil';
import { Platform } from '../../types/platform/platform';
import platformAtom from '../atom/platform';

const contactInfo = selector<Platform['contactInfo']>({
  key: 'platformContactInfo',
  get: ({ get }) => {
    const platform = get(platformAtom);
    return platform.contactInfo;
  },
});

export default contactInfo;
